import getSmimeInfobarMessageFromErrorCode from './getSmimeInfobarMessageFromErrorCode';
import isClearSignedItem from './isClearSignedItem';
import isSMIMEItem from './isSMIMEItem';
import SmimeContext from '../store/schema/SmimeContext';
import { ClientItem } from 'owa-mail-store';
import Message from 'owa-service/lib/contract/Message';
import {
    MessagePart,
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

const getSmimeDecodeErrorInfoBarMessage = (
    message: Message,
    key: string,
    isConversationItemPart: boolean
): InfoBarMessageViewState => {
    const item = <ClientItem>message;

    if (isConversationItemPart || !(isSMIMEItem(item) && item.Smime && item.Smime.ErrorState)) {
        return null;
    }

    const smimeContext: SmimeContext = isClearSignedItem(item)
        ? SmimeContext.ReadingSignedMessage
        : SmimeContext.ReadingEncryptedMessage;

    const messageParts: [string, ...MessagePart[]] = getSmimeInfobarMessageFromErrorCode(
        item.Smime.ErrorState,
        smimeContext
    );

    return {
        key,
        message: messageParts[0],
        messageParts: messageParts,
        rank: InfoBarMessageRank.Error,
        source: InfoBarMessageSource.ReadingPane,
    };
};

export default getSmimeDecodeErrorInfoBarMessage;
